import CheckoutCard from './CheckoutCard';
import Divider from './Divider';
import Edit from './Edit';
import Summary from './Summary';

CheckoutCard.Divider = Divider;
CheckoutCard.Edit = Edit;
CheckoutCard.Summary = Summary;

export default CheckoutCard;
